export const getReportName = (options) => {
  if (options && options.reports && options.reports.length) {
    return options.reports[0].name
  }
}

export default { getReportName }
